/**
 * Redirect a /evaluations/questionnaires.
 *
 * El landing original de /evaluations (dashboard de assessments) está pausado
 * — vive en /evaluations/assessments aún funcional pero no enlazado.
 * Cuando se reactiven los marcos de evaluación, revertir este archivo al
 * componente AssessmentsPage. Ver EVALUATIONS_PAUSED.md.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/evaluations/")({
  beforeLoad: () => {
    throw redirect({ to: "/evaluations/questionnaires" });
  },
});
